import { Injectable } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import * as moment from 'moment';
import 'rxjs/add/operator/map';

@Injectable()
export class Utility {
    constructor() { 
    }
    
    public static getRandomInt(min: number, max: number) {
        return Math.random() * (max - min) + min;
    }

    public static map(to: any, from: any) {
        for (let key in to) {
            to[key] = from[key];
        }
        return to;
    }

    public static formatLongDate(date) {
        return moment(date).format("MMMM D, YYYY");
    }

    public static parseLongDate(string) {
        return moment(string, "MMMM D, YYYY").toDate();
    }

    public static toUTCDate(date) {
        return (new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()));
    };

    public static toShortDate(date) {
        var options = { year: 'numeric', month: 'long', day: 'numeric' };
        return (date.toLocaleString('en-US', options));
    }

    public static objectToFormData = function(obj: any, form?: FormData, namespace?: string) {
        var fd = form || new FormData();
        var formKey;
    
        for(var property in obj) {
            if(obj.hasOwnProperty(property)) {
                if(namespace) {
                    formKey = namespace + '[' + property + ']';
                } else {
                    formKey = property;
                }
                if(typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
                    this.objectToFormData(obj[property], fd, property);
                } else {
                    if(obj[property] instanceof File) {
                        fd.append(formKey, obj[property], obj[property].name);
                    } else {
                        fd.append(formKey, obj[property]);
                    }
                }
            }
        }
        return fd;
    };

    public static maskPhone(form: FormGroup, input: string) {
        try {
            // Remove invalid chars from the inputValue
            let inputValue = form.value[input].replace("+1", "").replace(/[^0-9\(\)\s\-]/g, "");
            let inputValuelen = inputValue.length;
            // Get just the numbers in the inputValue
            let numbers = form.value[input].replace(/\D/g, '');
            let numberslen = numbers.length;
            // Value to store the masked inputValue
            var newval = "";

            // Loop through the existing numbers and apply the mask
            for (var i = 0; i < numberslen; i++) {
                if (i == 0) newval = "(" + numbers[i];
                else if (i == 3) newval += ") " + numbers[i];
                else if (i == 6) newval += "-" + numbers[i];
                else newval += numbers[i];
            }

            // Re-add the non-digit characters to the end of the inputValue that the user entered and that match the mask.
            if (inputValuelen >= 1 && numberslen == 0 && inputValue[0] == "(") newval = "(";
            else if (inputValuelen >= 6 && numberslen == 3 && inputValue[4] == ")" && inputValue[5] == " ") newval += ") ";
            else if (inputValuelen >= 5 && numberslen == 3 && inputValue[4] == ")") newval += ")";
            else if (inputValuelen >= 6 && numberslen == 3 && inputValue[5] == " ") newval += " ";
            else if (inputValuelen >= 10 && numberslen == 6 && inputValue[9] == "-") newval += "-";

            (<FormControl>form.controls[input]).setValue(newval.substring(0, 14), { onlySelf: true });
        } catch (ex) {

        }
    }

    public static uniq(items): Array<any> {
        var prims = { "boolean": {}, "number": {}, "string": {} }, objs = [];

        return items.filter(function (item) {
            var type = typeof item;
            if (type in prims)
                return prims[type].hasOwnProperty(item) ? false : (prims[type][item] = true);
            else
                return objs.indexOf(item) >= 0 ? false : objs.push(item);
        });
    }

    public static uniqueArray(arrArg) {
        return arrArg.filter(function (elem, pos, arr) {
            return arr.indexOf(elem) == pos;
        });
    };

    public static convertToLocalDateInputFormatZero(date) {
        return date.getFullYear() + "-" + ("00" + (date.getMonth() + 1)).substr(-2) + "-" + ("00" + date.getDate()).substr(-2);
    }

    public static sanitizePhoneNumber(phoneNumber:string){
        if(phoneNumber){
            phoneNumber = phoneNumber.replace('-', '').replace('(', '').replace(')', '').replace(' ', '').replace('+', '');
            return (phoneNumber.length == 11 && phoneNumber.substr(0,1) == '1') ? phoneNumber.substr(1,11) : phoneNumber
        }
        return phoneNumber;
    }

    public static padStart(padWith:string, toPad:any, size:number): string {
        var str = toPad+"";
        while (str.length < size) str = padWith + str;
        return str;
    }
}